import { FormFieldsApiType } from 'src/publisher/api/form-opt-in-api'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { CustomFieldSlugType } from 'src/shared/schemas/field/common-field-entity-and-sub-entity.schema'
import { FieldsValuesType } from '../context/form-context'

export const convertFormFieldValuesToFormFieldApi = (
  fieldsValues: FieldsValuesType,
): FormFieldsApiType =>
  Object.entries(fieldsValues).map(([slug, value]) => ({
    slug: slug as ContactSlugEnum | CustomFieldSlugType,
    value,
  }))
